// Carrito del tema: cajón lateral sobre el carrito real de Shopify.
//
// Sustituye al carrito del sitio headless, que guardaba líneas y cantidades en
// localStorage. Aquí NO se guarda nada en el navegador: el carrito de Shopify
// vive en el servidor y es el mismo que cobra en el checkout. Una copia local
// sería una segunda fuente de verdad y acabaría enseñando algo distinto de lo
// que se cobra, que es el fallo que este proyecto lleva evitando desde el
// primer día.
//
// Todo lo que hace este archivo es una mejora encima del HTML que ya funciona:
// el formulario de la ficha es el nativo de Shopify, así que si este script
// falla o no llega a cargar, añadir al carrito sigue funcionando y el navegador
// lleva al cliente a /cart. Nunca se queda sin poder comprar.

const $ = (s, r = document) => r.querySelector(s);
const cajon = $('[data-carrito]');
const velo = $('[data-velo]');

if (cajon && velo) {
  const rutas = window.PDS?.rutas ?? {
    carrito: '/cart', anadir: '/cart/add.js', cambiar: '/cart/change.js', checkout: '/checkout'
  };
  let ultimoFoco = null;

  // --- Abrir y cerrar -----------------------------------------------------
  function abrir() {
    ultimoFoco = document.activeElement;
    velo.hidden = false;
    cajon.hidden = false;
    // Doble rAF: sin esto el navegador aplica el estado final en el mismo
    // fotograma en que quita el hidden y no hay transición que ver.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      cajon.classList.add('abierto');
      velo.classList.add('abierto');
    }));
    // Bloqueo en <html> Y en <body>: con uno solo, iOS sigue arrastrando la
    // página por debajo del panel.
    document.documentElement.classList.add('sin-scroll');
    document.body.classList.add('sin-scroll', 'cajon-abierto');
    $('[data-cerrar-carrito]', cajon)?.focus();
  }

  function cerrar() {
    cajon.classList.remove('abierto');
    velo.classList.remove('abierto');
    document.documentElement.classList.remove('sin-scroll');
    document.body.classList.remove('sin-scroll', 'cajon-abierto');
    const fin = () => { cajon.hidden = true; velo.hidden = true; };
    // Respaldo por temporizador: si la transición no llega a dispararse (por
    // prefers-reduced-motion, por ejemplo), el cajón se quedaría visible pero
    // inerte. Con el respaldo siempre acaba oculto.
    let hecho = false;
    const unaVez = () => { if (!hecho) { hecho = true; fin(); } };
    cajon.addEventListener('transitionend', unaVez, { once: true });
    setTimeout(unaVez, 400);
    ultimoFoco?.focus();
  }

  // --- Refresco desde el servidor ----------------------------------------
  // Se vuelve a pedir la página y se extrae el cajón ya pintado por Liquid. Así
  // el HTML del carrito se escribe en UN solo sitio (el snippet) en vez de una
  // vez en Liquid y otra en JavaScript, que es como se desincronizan.
  async function refrescar() {
    const html = await fetch(rutas.carrito, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nuevo = doc.querySelector('[data-carrito]');
    if (!nuevo) return;
    $('[data-carrito-lista]', cajon).innerHTML = $('[data-carrito-lista]', nuevo).innerHTML;
    const pieViejo = $('[data-carrito-pie]', cajon);
    const pieNuevo = $('[data-carrito-pie]', nuevo);
    pieViejo.innerHTML = pieNuevo.innerHTML;
    pieViejo.hidden = pieNuevo.hidden;

    // querySelectorAll y no querySelector: desde el 22/08 hay DOS botones de
    // carrito en el HTML —el de la barra de escritorio y el de dentro del menú
    // de móvil— y solo uno se ve a la vez. Con querySelector se refrescaba
    // siempre el primero, que en móvil es justo el que está oculto: el
    // contador se quedaba clavado en el que sí se ve.
    const cuenta = doc.querySelector('[data-carrito-cuenta]')?.textContent ?? '0';
    document.querySelectorAll('[data-carrito-cuenta]').forEach(e => { e.textContent = cuenta; });
    const vacio = cuenta.trim() === '0' ? 'si' : 'no';
    document.querySelectorAll('[data-abrir-carrito]').forEach(e => { e.dataset.vacio = vacio; });
  }

  function error(mensaje) {
    const caja = $('[data-carrito-error]', cajon);
    if (caja) caja.textContent = mensaje;
  }

  async function pedir(ruta, cuerpo) {
    const r = await fetch(ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    });
    const datos = await r.json().catch(() => null);
    if (!r.ok) {
      // Shopify devuelve en `description` un mensaje que entiende el cliente
      // ("solo quedan 2 unidades"). Es mejor que un código de estado pelado.
      throw new Error(datos?.description || 'No hemos podido actualizar el carrito.');
    }
    return datos;
  }

  // --- Añadir desde la ficha ---------------------------------------------
  // Se intercepta el envío del formulario nativo. Si algo falla, se deja que el
  // navegador lo envíe de la forma clásica: el cliente acaba en /cart, que es
  // feo pero funciona.
  document.addEventListener('submit', async (ev) => {
    const form = ev.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    ev.preventDefault();
    const boton = form.querySelector('[type=submit]');
    const textoOriginal = boton?.textContent;
    if (boton) { boton.disabled = true; boton.textContent = 'Añadiendo…'; }
    error('');
    try {
      await pedir(rutas.anadir, { items: [{ id: new FormData(form).get('id'), quantity: 1 }] });
      await refrescar();
      abrir();
    } catch (e) {
      error(e.message);
      abrir();
    } finally {
      if (boton) { boton.disabled = false; boton.textContent = textoOriginal; }
    }
  });

  // --- Cambios dentro del cajón ------------------------------------------
  // Delegación en el documento: el contenido se repinta entero en cada cambio,
  // así que enganchar los eventos a cada botón obligaría a re-engancharlos.
  document.addEventListener('click', async (ev) => {
    if (ev.target.closest('[data-abrir-carrito]')) { ev.preventDefault(); abrir(); return; }
    if (ev.target.closest('[data-cerrar-carrito]')) { cerrar(); return; }

    const pagar = ev.target.closest('[data-pagar]');
    if (pagar) { window.location.href = rutas.checkout; return; }

    const mas = ev.target.closest('[data-mas]');
    const menos = ev.target.closest('[data-menos]');
    const quitar = ev.target.closest('[data-quitar]');
    if (!mas && !menos && !quitar) return;

    const clave = (mas || menos || quitar).dataset.mas
      || (menos || quitar).dataset.menos
      || quitar.dataset.quitar;
    const fila = cajon.querySelector(`[data-linea="${CSS.escape(clave)}"]`);
    const actual = Number(fila?.querySelector('.contador__valor')?.textContent ?? 0);
    const cantidad = quitar ? 0 : (mas ? actual + 1 : actual - 1);

    error('');
    try {
      await pedir(rutas.cambiar, { id: clave, quantity: Math.max(0, cantidad) });
      await refrescar();
    } catch (e) { error(e.message); }
  });

  // Cerrar al tocar fuera con pointerdown y NO con click: si el ratón se mueve
  // un píxel entre pulsar y soltar, el click no llega a dispararse.
  velo.addEventListener('pointerdown', cerrar);

  document.addEventListener('keydown', (ev) => {
    if (ev.key === 'Escape' && !cajon.hidden) cerrar();
  });
}
